<template>
  <a-drawer placement="left" :closable="false" :visible="visible" :mask="false" :get-container="false"
    :wrap-style="{ position: 'absolute' }" :width="width" :zIndex="999">
    <div slot="title" style="margin-bottom: 0px">
      <div class="radius"></div>
      <div class="radius-title">区域停水管控</div>
    </div>
    <div class="bottom">
      <a-table rowKey="id" :data-source="dataList" :columns="columns" :loading="dataListLoading" :pagination="false"
        size="small">
        <!-- <div slot="nameAction" slot-scope="text">
          <a-tooltip :title="text">
            <div
              :title="text"
              :style="{maxWidth:'90px',whiteSpace:'nowrap',textOverflow:'ellipsis',overflow:'hidden',wordWrap:'break-word',wordBreak:'break-all'}"
            >{{text}}</div>
          </a-tooltip>
        </div>-->
        <span slot="action" slot-scope="text, record">
          <a @click="jumpFather(record)" style="color: #fff">展示</a>
          <a-divider type="vertical" />
          <a @click="details(record.geophysicalPointNumber)" style="color: #fff">详情</a>
        </span>
      </a-table>
    </div>
    <!-- <div>
      <a-button style="margin-left: 30px" type="primary" @click="queryLayerProperties">查询</a-button>
      <a-button style="margin-left: 8px" @click="reset">重置</a-button>
    </div> -->
  </a-drawer>
</template>

<script>
import { getPipeDiameterSize, getPipeLineMaterial } from '@/api/manage'
// import { geoserverWFS } from '@/api/manage'
export default {
  name: 'BigMapDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns: [
        {
          title: '名称',
          dataIndex: 'featurePoint'
        },
        {
          title: '物探点',
          dataIndex: 'geophysicalPointNumber'
        },
        {
          title: '连接点',
          dataIndex: 'connectionPointNumber'
        },
        // {
        //   title: 'X',
        //   dataIndex: 'coordinatePointX'
        // },
        // {
        //   title: 'Y',
        //   dataIndex: 'coordinatePointY'
        // },
        //
        // {
        //   title: '高程m',
        //   dataIndex: 'groundElevation',
        // },
        {
          title: '操作',
          // dataIndex: 'action',
          key: 'operation',
          // fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataListLoading: false,
      queryUrl: '/pipe-network/pipes/analysis-of-tube-burst',
      dataList: [],
      width: 512,

      addOrUpdateForm: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 24 }
      }
    }
  },
  computed: {
    rules () {
      return {}
    }
  },
  methods: {
    jumpFather (record) {
      this.$parent.removeLayerByName('停水管控')
      const dataPoinit = []
      dataPoinit.push(JSON.parse(record.geoJson).coordinates)
      this.$parent.simplePoint(dataPoinit, '停水管控')
    },
    details (id) {
      this.$emit('checkDetails', id)
    },
    check (id) {
      if (id) {
        this.getDataList(id)
      }
    },
    getDataList (id) {
      this.dataListLoading = true
      const params = {
        pipeLineLayerId: id
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // reset() {
    //   this.currentSelectLayerQueryType = ''
    //   this.layerPropertiesValues = ''
    //   this.layerPropertiesValues = []
    // },
    // handleChange(selectedItems) {
    //   this.selectedItems = selectedItems
    // },
    // queryLayerProperties() {
    //   let cql = `(is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}') and`
    //   if (this.currentSelectLayerQueryType && this.layerPropertiesValues) {
    //     if (this.currentSelectLayerQueryType !== 'geophysical_point_number') {
    //       let tmpCql = ''
    //       this.layerPropertiesValues.forEach((item, index) => {
    //         if (index === 0) {
    //           tmpCql += this.currentSelectLayerQueryType + `= '${item}'`
    //         } else {
    //           tmpCql += ' or ' + this.currentSelectLayerQueryType + `= '${item}'`
    //         }
    //       })
    //       cql = cql + '(' + tmpCql + ')'
    //     } else {
    //       cql = cql + ` ${this.currentSelectLayerQueryType} = '${this.layerPropertiesValue}'`
    //     }
    //   }
    //   // alert(cql)
    //   // geoserverWFS('smart_water', 'pipe_network', cql).then(res =>{
    //   //   console.log('geoserverwfs', res)
    //   // })
    //   this.$parent.queryWmsLayers('smart_water', 'smart_water:pipe_network', cql)
    // },
    close () {
      //   this.disableSubmit = false
    }

    // handleOk() {
    //   const that = this
    //   console.log(that.selectedRows)
    //   const arr = this.selectedRows
    //   this.$emit('close', arr)
    //   this.close()
    // }
  }
}
</script>

<style lang='less' scoped>
/deep/ .ant-drawer-content-wrapper {
  background: rgb(0, 32, 54);
  opacity: 0.75;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-wrapper-body {
  background: rgba(0, 32, 54, 0.75);
  /*opacity: 0.75;*/
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-header {
  background: rgba(8, 144, 242, 0.18);
  border-bottom: 0px solid #e8e8e8;
}

/deep/ .ant-table-thead {
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

.radius {
  float: left;
  width: 4px;
  height: 16px;
  background: #ffffff;
  border-radius: 0px;
}

.radius-title {
  margin-left: 15px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
}

.ant-drawer-body {
  padding: 0;
}

/deep/ .ant-table-tbody {
  color: #ffffff;
}

/deep/ .ant-table-placeholder {
  background: rgba(8, 144, 242, 0.18);
  border-bottom: 0px solid #e8e8e8;
}

/deep/ .ant-table-column-title {
  color: #ffffff;
}
</style>
